import React from 'react';
import logo1 from '../assets/logo1.webp';

import { FaYoutube, FaTwitter, FaInstagram, FaFacebook, FaEnvelope } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const { t } = useTranslation();

  return (
    <section id="footer" className="p-8 bg-gray-50 mt-8 mb-12" >
      <div className="container px-4 mx-auto">
        <div className="grid justify-between text-center gap-y-8 gap-x-12 lg:grid-cols-5 lg:text-left">
          {/* First Column */}
          <div className="lg:pr-8 lg:col-span-1">
            <img className="w-auto h-16 mx-auto lg:mx-0 sm:h-16" src={logo1} alt="Logo" />
            <p className="mt-5 text-sm leading-relaxed text-gray-600 sm:text-base sm:mt-7">
              {t('footer-info')}
            </p>
            <ul className="flex items-center justify-center mt-5 space-x-3 sm:mt-9 lg:justify-start">
              {/* Social Media Icons */}
            </ul>
          </div>

          {/* Second Column - Useful Links */}
          <div className="flex flex-col items-center lg:items-start lg:col-span-1">
            <p className="text-lg lg:text-xl font-bold tracking-widest text-red-600 uppercase sm:text-sm">
              {t('Useful Links')}
            </p>
            <ul className="mt-4 space-y-2 sm:mt-6 sm:space-y-4">
              <li>
                <button
                  onClick={() => scrollToElement('home')}
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Home')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToElement('scholarship-0')}
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Shani Mandir')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToElement('scholarship-1')}
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Scholarship')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToElement('scholarship-2')}
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Social Security')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToElement('scholarship-3')}
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Youth Empowerment')}
                </button>
              </li>
            </ul>
          </div>

          {/* Third Column - Useful Buttons */}
          <div className="flex flex-col items-center lg:items-start lg:col-span-1">
            <p className="text-lg lg:text-xl font-bold tracking-widest text-red-600 uppercase sm:text-sm">
              {t('Useful Buttons')}
            </p>
            <ul className="mt-4 space-y-2 sm:mt-6 sm:space-y-4">
              <li>
                <a
                  href="https://forms.gle/CSu8q4VhwmrWebfa7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center px-2 py-2 text-sm lg:text-base text-black transition-all duration-200 bg-gray-200 border border-gray-950 rounded-md lg:justify-start sm:text-base hover:bg-gray-300"
                >
                  {t('Donation')}
                </a>
              </li>
              <li>
                <a
                  href="https://forms.gle/MUaxKwQ6eVoFFoh88"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center px-2 py-2 text-sm lg:text-base text-black transition-all duration-200 bg-gray-200 border border-black rounded-md lg:justify-start sm:text-base hover:bg-gray-300"
                >
                  {t('Pooja Booking')}
                </a>
              </li>
              <li>
                <a
                  href="https://forms.gle/SojitoY3CDJyhkUPA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center px-2 py-2 text-sm lg:text-base text-black transition-all duration-200 bg-gray-200 border border-black rounded-md lg:justify-start sm:text-base hover:bg-gray-300"
                >
                  {t('Apply1')}
                </a>
              </li>
              <li>
                <a
                  href="https://forms.gle/SY2t1KCMLDPKJcC1A"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center px-2 py-2 text-sm lg:text-base text-black transition-all duration-200 bg-gray-200 border border-black rounded-md lg:justify-start sm:text-base hover:bg-gray-300"
                >
                  {t('Apply2')}
                </a>
              </li>
            </ul>
          </div>

          {/* Fourth Column - Contact Us */}
          <div className="flex flex-col items-center lg:items-start lg:col-span-2">
            <p className="text-lg lg:text-xl font-bold tracking-widest text-red-600 uppercase sm:text-sm">
              {t('Contact Us')}
            </p>
            <ul className="mt-4 space-y-2 sm:mt-6 sm:space-y-4">
              <li>
                <a className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600">
                  {t('mob')}
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/place/Shree+Shani+Mandir+-+Shree+Shaneswar+Mandir/@19.1217505,72.9317968,17z/data=!3m1!4b1!4m6!3m5!1s0x3be7c79a7f33cd45:0x3328fa33219c583a!8m2!3d19.1217505!4d72.9343717!16s%2Fg%2F1ptvtxmj5?entry=ttu&g_ep=EgoyMDI1MDMxMS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Address')}
                </a>
              </li>
              <li>
                <a
                  href="mailto:ssf@donate.gmail.com"
                  className="flex justify-center text-sm lg:text-base text-black transition-all duration-200 lg:justify-start sm:text-base hover:text-blue-600 focus:text-blue-600"
                >
                  {t('Email')}
                </a>
              </li>
            </ul>

            {/* 
            <div className="mt-6">
              <input
                type="email"
                placeholder={t('Email2')}
                className="px-4 py-2 mr-2 text-sm lg:text-base text-gray-700 border border-gray-300 rounded-md sm:text-base"
              />
              <button className="px-4 py-2 text-sm lg:text-base text-white bg-blue-600 rounded-md sm:text-base hover:bg-blue-700">
                {t('Subscribe')}
              </button>
            </div> */}


            <div className="flex justify-center mt-4 space-x-6 lg:justify-start">
              <a
                href="https://www.facebook.com/people/Shri-Shanaishwar-Foundation/100069744745828/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 hover:text-blue-800"
              >
                <FaFacebook size={28} />
              </a>
              <a
                href="https://www.youtube.com/@ShreeShanaishwarFoundation"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 hover:text-red-700"
              >
                <FaYoutube size={28} />
              </a>
              <a
                href="https://www.instagram.com/shreeshanaishwarfoundation/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-500 hover:text-pink-600"
              >
                <FaInstagram size={28} />
              </a>
              <a
                href="https://x.com/shrishanaishwar"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-500"
              >
                <FaTwitter size={28} />
              </a>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
